// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://guxhicoxjcwzvhfoffdy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd1eGhpY294amN3enZoZm9mZmR5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjExMTAwNDUsImV4cCI6MjA3NjY4NjA0NX0.NFqvRUuOKrWOi6zgBsQG-knjvBcJWhTpEhdkSIg29vA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});